import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { getFormattedCategory, isProductCategoryEmobility, isProductCategoryInternet, translateCategoryInstant } from '@mwe/utils';
import { Sparte } from '@mwe/models';

@Pipe({ name: 'translateCategory' })
export class TranslateCategoryPipe implements PipeTransform {
  private translateService = inject(TranslateService);

  transform(category: string, useFwTariffClassTranslation?: boolean): string {
    if (useFwTariffClassTranslation) {
      return this.translateService.instant(`products.category.details.${category.toLowerCase()}`);
    }
    if (category === Sparte.StromGas) {
      return this.translateService.instant(`products.category.${category.toLowerCase()}`);
    }
    const translation = translateCategoryInstant(category, this.translateService);
    if (isProductCategoryInternet(category) || isProductCategoryEmobility(category)) {
      return translation;
    }
    return getFormattedCategory(translation);
  }
}
